<template>
  <div class="grid-fund-review">
    <filterBar
      @updateFilters="updateFilters(...arguments)"
      :client="selectedClient"
      :fiduciary="selectedFiduciary"
      :hideFilters="hideFilters"
      @updateProductFunds="updateProduct"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { EventBus } from '@/utils/event-bus';
import FilterBar from '@/components/organisms/FilterBar';

export default {
  name: 'grid-fund-review',
  computed: {
    ...mapState({
      selectedFiduciary: (state) => state.user.fiduciary.id,
      selectedClient: (state) => state.grid.client.selected,
      selectedTab: (state) => state.grid.tab,
    }),
  },
  components: {
    FilterBar,
  },
  data() {
    return {
      currentFilters: {
        assets: [],
        categories: [],
        status: [],
      },
      allStatusMode: false,
      hideFilters: {
        updates: true,
      },
    };
  },
  created() {
    EventBus.$emit('search-clear');
  },
  methods: {
    updateFilters(filters, allStatus) {
      this.currentFilters.assets = filters.assets;
      this.currentFilters.categories = filters.categories;
      this.currentFilters.status = filters.status;
      this.currentFilters.reviewStatus = filters.reviewStatus;
      this.allStatusMode = allStatus;
    },
    updateProduct(product, productName, productCode) {
      this.$store.dispatch('setProduct', {
        code: productCode,
        listVisible: false,
        name: productName,
        selected: product,
      });
    },
  },
};
</script>

<style lang="scss">
.grid-fund-review {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  @media screen and (max-height: 624px) {
    .single-list, .multiple-list {
      max-height: 250px;
    }
  }
}
</style>
